import style from 'styled-components';
import { INPUT_BORDER_COLOR } from 'styled/constants';

export const StyledInput = style.div`
  .input-wrapper{
    border-width: ${props => props.borderWidth || '1px'};
    border-style: solid;
    border-color: ${props =>
      props.error
        ? props.theme.colors.alert
        : props.borderColor || INPUT_BORDER_COLOR};
    display: flex;
    width: 100%;
    height: ${props => props.height || '100px'};
    min-height: 50px;
    border-radius: 0;
    justify-content: center;
    align-items: center;
    font-weight: ${props => props.fontWeight || 500};
    font-size: ${props => props.fontSize || '1em'};
    padding-top:5px;
    color: ${props => props.color || props.theme.font.colors.secondary};
    span {
        display: flex;
        width: auto;
        height: 100%;
        margin-top: 5px;
        color: ${props =>
          props.iconColor || props.theme.colors.buttonPrimaryBg};
        justify-content: center;
        align-items: flex-start;
        padding-left: 10px;
        padding-right: 5px;
        font-size: ${props => props.fontSize || '1.2em'}
    }
    textarea {
        padding-left: 5px;
        width: 100%;
        height: 100%;
        border: none;
        &:focus {
            outline: none;
            box-shadow: none;
        }
    }
  }
  .error{
    width: 100%;
    padding-left: 10px;
    color: ${props => props.theme.colors.alert};
    font-style: italic
  }
  .label{
    font-weight: bold;
    margin-bottom: 5px;
  }
`;
